import type { ISbStoryData } from '@storyblok/js';
import type { PageNewsReferenceStoryblok } from '~/.storyblok/types/PageNewsReferenceStoryblok';

export function isPageNewsReference(story: ISbStoryData): story is ISbStoryData<PageNewsReferenceStoryblok> {
    const content = story.content;

    if (!content || typeof content !== 'object') {
        return false;
    }

    if (!('component' in content) || content.component !== 'PageNewsReference') {
        return false;
    }

    if (!('_uid' in content) || typeof content._uid !== 'string') {
        return false;
    }

    if (!('reference' in content)) {
        return false;
    }

    const { reference } = content;

    return reference === undefined || Array.isArray(reference);
}
